const HttpStatus = {
	OK: 200,
	CREATED: 201,
	BAD_REQUEST: 400,
	NOT_AUTHORIZED: 401,
	INTERNAL_SERVER_ERROR: 500,
};

export default HttpStatus;
